// extracted by mini-css-extract-plugin
module.exports = {"header":"q_z g_p","logo":"q_B"};